<template>
  <div class="bg-white p-4 rounded shadow-sm mb-4">
    <h2 class="mb-3">🏘 {{ complex.name }}</h2>
    <p class="text-muted">
      {{ complex.city_name }}{{ complex.address ? ' | ' + complex.address : '' }}
    </p>

    <div v-if="complex.description" class="mb-3">
      <h5>{{ $t('residential_complex.complex.details.description') }}</h5>
      <div v-html="complex.description" class="small lh-base"></div>
    </div>

    <div
      v-if="complex.infrastructure && Object.keys(complex.infrastructure).length"
      class="mb-3"
    >
      <h5>{{ $t('residential_complex.complex.details.infrastructure') }}</h5>
      <ul class="list-unstyled small">
        <li v-for="(v, k) in complex.infrastructure" :key="k" v-if="v">🏙️ {{ $t(`complex.infrastructure.${k}`) }}</li>
      </ul>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  complex: Object
})
</script>
